import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MyJourneyComponent } from './components/my-journey/my-journey.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: MyJourneyComponent,
        pathMatch: 'full'
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MyJourneyRoutingModule { }
